import { useMatches } from "react-router";

import { isSiteHeaderHidden } from "~/feature/pages/utils/isSiteHeaderHidden";

export const useIsSiteHeaderHidden = (): boolean =>
  isSiteHeaderHidden(useMatches());
